import { SITE_URL } from "@/lib/site-url";

/** Datos estructurados de tarifas: los 4 planes mensuales en EUR. */
const PLANS = [
  { es: "Lite", en: "Lite", price: "0", quota: 3 },
  { es: "Básico", en: "Basic", price: "39", quota: 30 },
  { es: "Club Pro", en: "Club Pro", price: "69", quota: 60 },
  { es: "Avanzado", en: "Advanced", price: "99", quota: 100 },
];

export function pricingJsonLd(lang: "es" | "en") {
  const url = `${SITE_URL}${lang === "es" ? "/tarifas" : "/en/pricing"}`;
  return {
    "@context": "https://schema.org",
    "@type": "Product",
    name: "Retail Lemon",
    brand: { "@type": "Brand", name: "Retail Lemon" },
    url,
    description:
      lang === "es"
        ? "Panel y Agente Retail IA para comercios. Planes mensuales sin permanencia; 7 días de prueba gratis en los planes de pago, una vez por persona; bajas al final del periodo pagado."
        : "Dashboard and Retail AI Agent for shops. Monthly plans with no commitment; 7-day free trial on paid plans, once per person; cancellations take effect at period end.",
    offers: {
      "@type": "AggregateOffer",
      priceCurrency: "EUR",
      lowPrice: "0",
      highPrice: "99",
      offerCount: PLANS.length,
      offers: PLANS.map((p) => ({
        "@type": "Offer",
        name: p[lang],
        price: p.price,
        priceCurrency: "EUR",
        url,
        availability: "https://schema.org/InStock",
        description:
          lang === "es"
            ? `${p.quota} consultas al Agente Retail IA al mes${p.price === "0" ? ", gratis" : ", pago mensual sin permanencia"}`
            : `${p.quota} Retail AI Agent queries per month${p.price === "0" ? ", free" : ", monthly billing, no commitment"}`,
        ...(p.price !== "0" && {
          priceSpecification: {
            "@type": "UnitPriceSpecification",
            price: p.price,
            priceCurrency: "EUR",
            billingDuration: "P1M",
            unitCode: "MON",
          },
        }),
      })),
    },
  };
}
